import React, {Component, PropTypes} from 'react'
import {Col, Row, Form, FormGroup, Button} from 'react-bootstrap'
import HorseSeeker from './HorseSeeker/HorseSeeker'
import {Actions} from 'jumpstate'
import HorseName from './HorseName/HorseName'
import Datepicker from './Datepicker/Datepicker'
import Breeder from './Breeder/Breeder'
import Colors from './Colors/Colors'
import Toggle from 'react-bootstrap-toggle'
import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css'
import NewHorseAvatar from './NewHorseAvatar'

class NewHorseDetails extends Component {
  constructor (props) {
    super(props)
    this.submit = this.submit.bind(this)
    this.state = {
      details: props.horse,
      errors: props.errors,
      touched: props.touched
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({details: nextProps.horse, errors: nextProps.errors, touched: nextProps.touched})
  }

  submit (e) {
    e.preventDefault()
    Actions.setAllNewHorseFieldsTouched()
    Actions.validateNewHorseData()
    this.props.saveHorse()
  }

  render () {
    const {details, errors, touched} = this.state
    const {avatar} = this.props
    const hasTouched = (fieldName) => {
      return touched.indexOf(fieldName) !== -1
    }
    const onToggle = () => {
      Actions.setNewHorseDetails({gender: details.gender === 'female' ? 'male' : 'female'})
    }
    const showGoodStrain = () => {
      if (details.dam.strain && details.sire.strain) {
        return details.dam.strain === details.sire.strain ? 'تیره همسان' : 'تیره ناهمسان'
      }
      return 'نامشخص'
    }

    return (
      <Col lg={5} lgOffset={1} md={6} mdOffset={0} sm={10} smOffset={1} xs={12} xsOffset={0}>
        <Form onSubmit={this.submit}>
          <Row className="Box">
            <Col xs={12}>
              <Row>
                <Col xs={3} className="Sire NewHorse">
                  <HorseSeeker name="sire_id" gender="sire" placeholder="اسم پدر" valueObject={details.sire} errors={hasTouched('sire_id') ? errors['sire_id'] : undefined} />
                </Col>
                <Col xs={6} className="Horse NewHorse">
                  <Row>
                    <NewHorseAvatar avatar={avatar} />
                    <HorseName name={details.name} nameFa={details.name_fa} placeholder="نام اسب" errors={errors} touched={touched} />
                    <h6 className="Strain">{details.strain ? details.strain : 'تیره'}</h6>
                  </Row>
                </Col>
                <Col xs={3} className="Dam NewHorse">
                  <HorseSeeker name="dam_id" gender="dam" placeholder="اسم مادر" valueObject={details.dam} errors={hasTouched('dam_id') ? errors['dam_id'] : undefined} />
                </Col>
              </Row>
              <Row className="Info TopBox">
                <Col xs={4}>
                  <h7>تیره همسان</h7>
                  <p>{showGoodStrain()}</p>
                </Col>
                <Col xs={4}>
                  <h7>رنگ</h7>
                  <Colors defaultColor={details.color.name} placeholder="رنگ" errors={hasTouched('color_id') ? errors['color_id'] : undefined} />
                </Col>
                <Col xs={4}>
                  <h7>جنسیت</h7>
                  <Toggle
                    onClick={onToggle}
                    on="مادیان"
                    off="نریان"
                    size="xs"
                    offstyle="danger"
                    active={details.gender === 'female'}
                  />
                </Col>
              </Row>
              <Row className="Info BottomBox">
                <Col xs={4}>
                  <h7>تولد</h7>
                  <FormGroup bsSize="sm">
                    <Datepicker gregorianFieldName="birth_date" jalaaliFieldName="birth_date_fa" placeholder="1372" gregorianValue={details.birth_date} jalaaliValue={details.birth_date_fa} errors={errors} touched={touched} />
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <h7>مرگ</h7>
                  <FormGroup bsSize="sm">
                    <Datepicker gregorianFieldName="death_date" jalaaliFieldName="death_date_fa" placeholder="-" gregorianValue={details.death_date} jalaaliValue={details.death_date_fa} errors={errors} touched={touched} />
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <h7>پرورش‌دهنده</h7>
                  <FormGroup bsSize="sm">
                    <Breeder breeder={details.breeder} breeder_id={details.breeder_id} breeder_fa={details.breeder_fa} placeholder={details.breeder_fa || 'پرورش دهنده'} errors={errors} touched={touched} />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>

          <FormGroup className="MHolder">
            <Col xsOffset={0} xs={12} md={8}>
              <Button type="submit" bsStyle="success" className="btnBlock" >
                ثبت
              </Button>
            </Col>
            <Col xsOffset={0} xs={12} md={4}>
              <Button onClick={() => this.props.clearHorse()} bsStyle="warning" className="btnBlock" >
                پاک کردن فرم
              </Button>
            </Col>
          </FormGroup>

        </Form>
      </Col>
    )
  }
}

NewHorseDetails.propTypes = {
  horse: PropTypes.object.isRequired,
  avatar: PropTypes.object.isRequired,
  saveHorse: PropTypes.func.isRequired,
  touched: PropTypes.array,
  clearHorse: PropTypes.func
}

export default NewHorseDetails



// WEBPACK FOOTER //
// ./src/components/NewHorse/NewHorseDetails.js